/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import createTypography from '../utils/createTypography';

export const Link = React.forwardRef((props, ref) => {
  const {
    children,
    href,
    underline,
    subtle,
    ...other
  } = props;

  const typography = createTypography({
    variant: 'body-base'
  });

  const linkClasses = classNames(typography.classes, {
    'sui-text-primary sui-underline': !subtle,
    'sui-text-subtle hover:sui-text-primary hover:sui-underline focus-visible:sui-text-primary': subtle,
    'sui-underline': underline && subtle
  }, 'focus-visible:sui-bg-focus focus-visible:sui-outline-none');

  return (
    <a href={href} ref={ref} className={linkClasses} {...other}>
      {children}
    </a>
  );
});

Link.displayName = 'Link';

Link.propTypes = {
  /**
   *@ignore
   */
  children: PropTypes.string,
  /**
   *The URL of the page the Link component goes to.
   */
  href: PropTypes.string,
  /**
   * Add underline to Link component.
   */
  underline: PropTypes.bool,
  /**
   * Add subtle text color to Link component.
   */
  subtle: PropTypes.bool
};

Link.defaultProps = {
};
